import { Injectable, signal } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { iOS } from '@libs/helper/helper';
import { DEVICE, IGeoip, ITelegramUserFrom } from '@libs/interfaces';
@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  displayWidth = signal(0);
  telegramUser = signal<ITelegramUserFrom | null>(null);
  telegramMiniApp = signal<boolean>(false);

  private TABLET_WIDTH = 540;
  device = signal<DEVICE>(DEVICE.DESKTOP);
  isMobile = signal(false);
  isTablet = signal(false);
  isDesktop = signal(false);
  isIphone = signal(false);
  isIpad = signal(false);
  isAndroid = signal(false);
  iOS = iOS();

  deviceType;
  orientation: 'portrait' | 'landscape';
  os = signal('');
  os_version = signal('');
  geoip = signal<IGeoip>(null);
  constructor(private deviceService: DeviceDetectorService) {}

  /**
   * Initializes the device service by detecting the device type, OS, and orientation.
   * Dispatches the device type to the store.
   */
  init() {
    const di = this.deviceService.getDeviceInfo();
    this.isTablet.set(di.deviceType == 'tablet' && window.innerWidth > this.TABLET_WIDTH);
    this.isMobile.set(
      di.deviceType == 'mobile' || (di.deviceType == 'tablet' && window.innerWidth <= this.TABLET_WIDTH),
    );
    this.device.set(this.isMobile() ? DEVICE.MOBILE : DEVICE.DESKTOP);
    this.isDesktop.set(this.deviceService.isDesktop());
    this.isIphone.set(iOS() && this.isMobile());
    this.isIpad.set(iOS() && this.isTablet());
    this.isAndroid.set(this.isMobile() && !iOS());
    this.deviceType = di.deviceType;
    this.os.set(di.os);
    this.os_version.set(di.os_version);
    this.orientation = di.orientation as 'portrait' | 'landscape';
  }

  /**
   * Returns the type of screen device based on the detected device properties.
   * @returns A string representing the screen device type.
   */
  screenDeviceType() {
    if (this.isIpad) return 'ipad';
    else if (this.isIphone) return 'iphone';
    else if (this.isTablet) return 'tablet';
    else if (this.isAndroid) return 'android';
    else return 'desktop';
  }
}
